import { useFormContext } from 'react-hook-form';
import { Grid } from '@mui/material';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { ICarrier, ICustomer } from '@/types';

const CommonData = () => {
  const form = useFormContext<ICustomer | ICarrier>();
  const entityDetails = form.watch("entityDetails" as any) as any;
  return (
    <Grid container spacing={2}>
      {entityDetails?.entity_type && (
        <Grid item xs={12} md={6}>
          <Controller
            name={"entityDetails.entity_type" as any}
            control={form.control}
            render={({ field }) => (
              <TextField  {...field} size='small' inputProps={{
                readOnly: true,
              }} fullWidth label="Entity Type" InputLabelProps={{ shrink: true }} />
            )}
          />
        </Grid>
      )}
      {/* show carrier carrier_operation it is an array of strings */}
      {(() => {
        const carrierOps = entityDetails?.carrier_operation;
        return carrierOps && carrierOps.length > 0 && (
          <Grid item xs={12} md={6}>
            <TextField size='small'
              value={carrierOps.join(', ')}
              inputProps={{
                readOnly: true,
              }}
              fullWidth
              label="Carrier Operation"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        );
      })()}
      {
        entityDetails?.operating_status && (
          <Grid item xs={12} md={6}>
            <Controller
              name={"entityDetails.operating_status" as any}
              control={form.control}
              render={({ field }) => (
                <TextField  {...field} size='small' inputProps={{
                  readOnly: true,
                }} fullWidth label="Operating Status" InputLabelProps={{ shrink: true }} />
              )}
            />
          </Grid>
        )}
      {
        entityDetails?.dba_name && (
          <Grid item xs={12} md={6}>
            <Controller
              name={"entityDetails.dba_name" as any}
              control={form.control}
              render={({ field }) => (
                <TextField  {...field} size='small' inputProps={{
                  readOnly: true,
                }} fullWidth label="DBA Name" InputLabelProps={{ shrink: true }} />
              )}
            />
          </Grid>
        )
      }

      {
        entityDetails?.mailing_address && (
          <Grid item xs={12} md={12}>
            <Controller
              name={"entityDetails.mailing_address" as any}
              control={form.control}
              render={({ field }) => (
                <TextField {...field} inputProps={{
                  readOnly: true,
                }} multiline rows={1} fullWidth label="Mailing Address" InputLabelProps={{ shrink: true }} size='small' />
              )}
            />
          </Grid>
        )}

      {/* out of service date */}
      {
        entityDetails?.out_of_service_date && (
          <Grid item xs={12} md={6}>
            <Controller
              name={"entityDetails.out_of_service_date" as any}
              control={form.control}
              render={({ field }) => (
                <TextField
                  {...field}
                  size='small'
                  fullWidth
                  label="Out of Service Date"
                />
              )}
            />
          </Grid>
        )
      }
    </Grid>
  )
}

export default CommonData